<template>
  <FormSubmitPopup
    :title="$t(isEdit ? 'editUser' : 'addUser')"
    v-model="value"
    :rightMethod="onSubmitted"
    @popupClose="$emit('input', false)"
    large>
    <template v-slot:input>
      <v-layout>
        <v-flex md4>
          <v-text-field
            @keydown.enter="() => false"
            :label="$t('email')"
            v-model.trim="user.email"
            :rules="[fieldIsRequired('Email')]"
            :readonly="isEdit"></v-text-field>
        </v-flex>
        <v-flex md1></v-flex>
        <v-flex md4 v-if="isEdit">
          <v-text-field
            :label="$t('name')"
            v-model="user.name"
            :readonly="isEdit"></v-text-field>
        </v-flex>
      </v-layout>
      <v-list
        subheader
        three-line
      >
        <v-subheader>{{ $t('roles') }}</v-subheader>
          <v-layout wrap>
            <v-flex
              v-for="item in roles"
              :key="item.key"
              md6
            >
              <v-list-tile @click.stop="item.isSelected = !item.isSelected">
                <v-list-tile-action>
                  <v-checkbox
                    @click.stop="item.isSelected = !item.isSelected"
                    :value="item.isSelected"
                  ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title class="text-capitalize">{{ item.text }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ roleToComponentMap.get(item.key).join(', ') }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-flex>
            <v-flex
              md5
              v-if="isWarehouseOwner"
            >
              <v-select
                v-model="filterWarehouseSites"
                :items="warehousesSites"
                :label="$t('warehouseSites')"
                multiple
                chips
              >
                <template v-slot:prepend-item>
                  <v-list-tile
                    ripple
                    @mousedown.prevent
                    @click="selectAll"
                  >
                    <v-list-tile-action>
                      <v-icon color="#224855">{{ allIcon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ $t('selectAll') }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider class="mt-2"></v-divider>
                </template></v-select>
            </v-flex>
          </v-layout>
      </v-list>
      <v-layout row wrap v-if="isEdit">
        <v-flex>
          <v-textarea
            :label="$t('note')"
            v-model.trim="user.note"
            outline
            rows="3"
            :counter="200"
            auto-grow
          ></v-textarea>
        </v-flex>
      </v-layout>
    </template>
  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import { cloneDeep, checkRules } from '@/utils/tools'

export default {
  name: 'PermissionEditPopup',
  components: {
    FormSubmitPopup
  },
  mixins: [checkRules],
  data () {
    return {
      user: {},
      roles: (this.$store.getters.user.isAdmin ? this.$store.getters.adminRoles : this.$store.getters.allRoles)
        .map(role => {
          return {
            key: role,
            isSelected: false,
            text: this.$t(this.$store.getters.permissionValueToText.get(role))
          }
        })
        .filter(role => role.text),
      filterWarehouseSites: []
    }
  },
  mounted () {
    this.user = cloneDeep(this.initUser)
    const { roles, sites = [] } = this.user
    const roleSet = new Set(roles || [])
    this.roles.forEach(role => {
      if (roleSet.has(role.key)) {
        role.isSelected = true
      }
    })
    if (this.isWarehouseOwner) {
      this.filterWarehouseSites = sites.includes('all')
        ? this.warehousesSites.map(site => site.value)
        : sites
    }
  },
  computed: {
    isAdmin () {
      return !!this.$store.getters.user.isAdmin
    },
    permissionValueToText () {
      return this.$store.getters.permissionValueToText
    },
    roleToComponentMap () {
      return this.$store.getters.roleToComponentMap
    },
    warehousesSites () {
      return this.$store.getters.warehousesSites.map(site => ({
        text: site.siteName,
        value: site.key
      }))
    },
    isSelectAll () {
      const filterWarehouseSitesLen = this.filterWarehouseSites.length
      const warehouseSitesLen = this.warehousesSites.length
      return filterWarehouseSitesLen === warehouseSitesLen && filterWarehouseSitesLen > 0
    },
    allIcon () {
      if (this.isSelectAll) return 'check_box'
      else if (this.filterWarehouseSites.length > 0) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    }
  },
  methods: {
    onSubmitted () {
      const roles = this.roles
        .filter(role => role.isSelected)
        .map(role => role.key)
      const payload = { ...this.user, roles }
      if (this.isWarehouseOwner) {
        Object.assign(payload, {
          sites: this.isSelectAll
            ? ['all']
            : this.filterWarehouseSites
        })
        if (payload.sites.length > 10) {
          const msg = this.$t('exceedWarehouseSites')
          alert(msg)
          throw Error(msg)
        }
      }
      return this.actionFunc(payload)
    },
    selectAll () {
      this.filterWarehouseSites = this.isSelectAll
        ? []
        : this.warehousesSites.map(site => site.value)
    }
  },
  props: {
    isEdit: Boolean,
    actionFunc: Function,
    value: Boolean,
    initUser: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isWarehouseOwner: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PermissionEditPopup.vue